import localizationEnUsAddress from "./en-us/address.json";
import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsShipment from "./en-us/shipment.json";
import localizationEnUsSubtotal from "./en-us/subtotal.json";

export const localizationEnUsStoreCheckout = {
  ...localizationEnUsHeader,
  ...localizationEnUsAddress,
  ...localizationEnUsShipment,
  ...localizationEnUsSubtotal,
};
